import type { Tool } from '@/types';

/** The full catalogue of free / freemium AI tools featured on the platform. */
export const TOOLS: readonly Tool[] = [
  {
    name: 'ChatGPT',
    category: 'كتابة',
    description: 'كتابة النصوص التعليمية ومقررات الدروس بسهولة وسرعة باستخدام الذكاء الاصطناعي.',
    url: 'https://chat.openai.com/',
    monogram: 'GPT',
    domain: 'openai.com',
  },
  {
    name: 'Gemini AI',
    category: 'كتابة',
    description: 'مساعد ذكي من جوجل لكتابة النصوص والإجابة على الأسئلة والتحليل المتقدم.',
    url: 'https://gemini.google.com/',
    monogram: 'Gi',
    domain: 'gemini.google.com',
  },
  {
    name: 'Microsoft Copilot',
    category: 'كتابة',
    description: 'مساعد ذكي من مايكروسوفت لكتابة النصوص والإجابة على الأسئلة.',
    url: 'https://copilot.microsoft.com/',
    monogram: 'MC',
    domain: 'copilot.microsoft.com',
  },
  {
    name: 'منصة نور',
    category: 'رسمي',
    description: 'منصة تعليمية رسمية من وزارة التعليم لإدارة العملية التعليمية.',
    url: 'https://noor.moe.gov.sa/',
    monogram: 'نور',
    domain: 'moe.gov.sa',
  },
  {
    name: 'Canva',
    category: 'تصميم',
    description: 'تصميم صور وملصقات تعليمية جذابة وحديثة بدون الحاجة لخبرة في التصميم.',
    url: 'https://www.canva.com/',
    monogram: 'Cv',
    domain: 'canva.com',
  },
  {
    name: 'Prezi',
    category: 'عروض',
    description: 'عروض تقديمية متحركة تنتقل بين الأفكار على لوحة واحدة بدل الشرائح التقليدية.',
    url: 'https://prezi.com/',
    monogram: 'Pz',
    domain: 'prezi.com',
  },
  {
    name: 'Mootion',
    category: 'فيديو',
    description: 'توليد مقاطع موشن جرافيك وشخصيات متحركة من وصف نصي بسيط.',
    url: 'https://www.mootion.com/',
    monogram: 'Mo',
    domain: 'mootion.com',
  },
  {
    name: 'Kahoot',
    category: 'اختبارات',
    description: 'مسابقات واختبارات تفاعلية يشارك فيها الطلاب مباشرة داخل الحصة.',
    url: 'https://kahoot.com/',
    monogram: 'Kh',
    domain: 'kahoot.com',
  },
  {
    name: 'Flou',
    category: 'فيديو',
    description: 'أداة لإنشاء مقاطع فيديو متحركة احترافية وجذابة.',
    url: 'https://flou.io/',
    monogram: 'Fl',
    domain: 'flou.io',
  },
  {
    name: 'Crook',
    category: 'فيديو',
    description: 'منصة لإنشاء محتوى فيديو احترافي بسهولة وسرعة.',
    url: 'https://crook.io/',
    monogram: 'Ck',
    domain: 'crook.io',
  },
  {
    name: 'Kling AI',
    category: 'فيديو',
    description: 'توليد مقاطع فيديو واقعية من نص أو صورة باستخدام الذكاء الاصطناعي.',
    url: 'https://app.klingai.com/',
    monogram: 'Kl',
    domain: 'klingai.com',
  },
  {
    name: 'CapCut',
    category: 'فيديو',
    description: 'تطبيق تحرير الفيديوهات الاحترافي والسهل الاستخدام بمزايا ذكية.',
    url: 'https://www.capcut.com/',
    monogram: 'CC',
    domain: 'capcut.com',
  },
  {
    name: 'D-ID',
    category: 'فيديو',
    description: 'إنشاء فيديوهات باستخدام الذكاء الاصطناعي مع صور ثابتة.',
    url: 'https://d-id.com/',
    monogram: 'D·ID',
    domain: 'd-id.com',
  },
  {
    name: 'Vidnoz',
    category: 'فيديو',
    description: 'إنشاء فيديوهات تعليمية بمقدم افتراضي يتحدث بالعربية من نص مكتوب.',
    url: 'https://www.vidnoz.com/',
    monogram: 'Vd',
    domain: 'vidnoz.com',
  },
  {
    name: 'PicsArt',
    category: 'تصميم',
    description: 'تحرير الصور وتصميم المنشورات التعليمية بأدوات ذكية على الجوال والويب.',
    url: 'https://picsart.com/',
    monogram: 'PA',
    domain: 'picsart.com',
  },
  {
    name: 'Pinterest',
    category: 'تصميم',
    description: 'مصدر أفكار وصور للوسائل التعليمية وتنظيمها في لوحات حسب الموضوع.',
    url: 'https://www.pinterest.com/',
    monogram: 'Pn',
    domain: 'pinterest.com',
  },
  {
    name: 'Notebook Microsoft',
    category: 'ملاحظات',
    description: 'تطبيق ملاحظات رقمي متقدم للتنظيم والدراسة.',
    url: 'https://www.onenote.com/',
    monogram: 'NB',
    domain: 'onenote.com',
  },
  {
    name: 'Adobe Express',
    category: 'تصميم',
    description: 'تصميم ملصقات وفيديوهات قصيرة من قوالب جاهزة بأدوات ذكاء اصطناعي.',
    url: 'https://www.adobe.com/express/',
    monogram: 'AE',
    domain: 'adobe.com',
  },
  {
    name: 'Beautiful.ai',
    category: 'عروض',
    description: 'إنشاء عروض تقديمية احترافية وذكية بتصاميم حديثة وجاهزة.',
    url: 'https://www.beautiful.ai/',
    monogram: 'B.ai',
    domain: 'beautiful.ai',
  },
  {
    name: 'Murf.ai',
    category: 'صوت',
    description: 'تحويل النصوص إلى كلام طبيعي واحترافي لإنشاء محتوى صوتي تعليمي.',
    url: 'https://murf.ai/',
    monogram: 'M.ai',
    domain: 'murf.ai',
  },
  {
    name: 'Powtoon',
    category: 'فيديو',
    description: 'إنشاء فيديوهات متحركة وجذابة للشرح والعروض التقديمية.',
    url: 'https://www.powtoon.com/',
    monogram: 'Pw',
    domain: 'powtoon.com',
  },
  {
    name: 'Animaker',
    category: 'فيديو',
    description: 'صناعة فيديوهات متحركة احترافية لشرح المفاهيم والدروس.',
    url: 'https://www.animaker.com/',
    monogram: 'Am',
    domain: 'animaker.com',
  },
  {
    name: 'Khan Academy',
    category: 'موارد',
    description: 'مكتبة ضخمة من الموارد التعليمية المجانية والشاملة.',
    url: 'https://www.khanacademy.org/',
    monogram: 'KA',
    domain: 'khanacademy.org',
  },
  {
    name: 'Google Slides',
    category: 'عروض',
    description: 'إنشاء عروض تقديمية احترافية وسهلة المشاركة والتعديل.',
    url: 'https://slides.google.com/',
    monogram: 'GS',
    domain: 'slides.google.com',
  },
  {
    name: 'Google Forms',
    category: 'اختبارات',
    description: 'إنشاء استبيانات واختبارات تفاعلية وجمع الإجابات تلقائياً.',
    url: 'https://forms.google.com/',
    monogram: 'GF',
    domain: 'forms.google.com',
  },
  {
    name: 'Loom',
    category: 'تسجيل',
    description: 'تسجيل الشاشة والفيديوهات لشرح الدروس والعمليات التقنية.',
    url: 'https://www.loom.com/',
    monogram: 'Lm',
    domain: 'loom.com',
  },
  {
    name: 'Google Sites',
    category: 'مواقع',
    description: 'تصميم مواقع تعليمية بسيطة وسهلة التعديل بدون أكواد.',
    url: 'https://sites.google.com/',
    monogram: 'GSt',
    domain: 'sites.google.com',
  },
  {
    name: 'Quizlet',
    category: 'اختبارات',
    description: 'إنشاء بطاقات تعليمية تفاعلية واختبارات للمراجعة والتعلم.',
    url: 'https://quizlet.com/',
    monogram: 'Qz',
    domain: 'quizlet.com',
  },
  {
    name: 'Padlet',
    category: 'تعاون',
    description: 'منصة تعاون جماعي لمشاركة الأفكار والمشاريع والمحتوى التعليمي.',
    url: 'https://padlet.com/',
    monogram: 'Pd',
    domain: 'padlet.com',
  },
  {
    name: 'Gamma AI',
    category: 'عروض',
    description: 'إنشاء عروض تقديمية احترافية باستخدام الذكاء الاصطناعي بدون تصميم يدوي.',
    url: 'https://gamma.app/',
    monogram: 'Gm',
    domain: 'gamma.app',
  },
  {
    name: 'Pixlr & Pixlr AI',
    category: 'تصميم',
    description: 'تطبيق تحرير الصور المتقدم مع ميزات الذكاء الاصطناعي للتصميم.',
    url: 'https://pixlr.com/',
    monogram: 'Px',
    domain: 'pixlr.com',
  },
  {
    name: 'Hydra',
    category: 'فيديو',
    description: 'أداة متقدمة للعمل مع الفيديوهات والمحتوى البصري.',
    url: 'https://hydra.app/',
    monogram: 'Hy',
    domain: 'hydra.app',
  },
  {
    name: 'Forms & Notes',
    category: 'اختبارات',
    description: 'أدوات متكاملة لإنشاء استبيانات وملاحظات رقمية وتنظيمها.',
    url: 'https://www.microsoft.com/en-us/microsoft-365/forms/online-surveys',
    monogram: 'F&N',
    domain: 'microsoft.com',
  },
  {
    name: 'GENIE AI',
    category: 'كتابة',
    description: 'أداة ذكاء اصطناعي متقدمة لإنشاء محتوى متنوع وإبداعي.',
    url: 'https://geniekids.com/',
    monogram: 'GN',
    domain: 'geniekids.com',
  },
  {
    name: 'GitHub Copilot',
    category: 'برمجة',
    description: 'مساعد ذكي لكتابة الأكواد والبرمجة بسهولة مع اقتراحات ذكية.',
    url: 'https://github.com/features/copilot',
    monogram: 'GH',
    domain: 'github.com',
  },
] as const;

/** Ordered category filter row; `null` represents “all”. */
export const TOOL_CATEGORIES = [
  'كتابة',
  'تصميم',
  'عروض',
  'صوت',
  'فيديو',
  'موارد',
  'اختبارات',
  'تسجيل',
  'مواقع',
  'تعاون',
  'ملاحظات',
  'برمجة',
  'رسمي',
] as const;
